<template>
  <ul class="radiobutton-group" :class="options.css_classes">
    <li v-for="(item, index) in options.source" :key="index">
      <label>
        <input 
          type="radio" 
          :value="item.value" 
          :name="'field-' + options.id" 
          v-model="fieldValue" 
          class="radio" />
          {{item.label}}
      </label>
    </li>
  </ul>
</template>

<script>
export default { 
  name: 'RadioButtonGroup',
  props: {
    options: {
      type: Object,
      required: true
    },
    value: {
      type: String
    }
  },
  methods: {
    validate () {
      if (this.value !== '') {
        return true
      }
      return false
    }
  },
  computed: {
    fieldValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$commit.setFieldValue({
          key: 'field-' + this.options.id, 
          value: val
        })
      }
    }
  }
}
  
</script>
